import { Cities } from "./Cities";
import { Zipcodes } from "./Zipcodes";
import styles from './styles.module.scss';

export function DeliveryLocations({ deliveryZips, locations, cities, showCities, showZipcodes }) {
  return (
    <div className={styles.wrapper}>
      {showCities && <div className={styles.cities}>
        <Cities deliveryZips={deliveryZips} locations={locations} cities={cities}/>
      </div>}
      {showZipcodes && <div className={styles.zipcodes}>
        <Zipcodes deliveryZips={deliveryZips} />
      </div>}
    </div>
  )
}